import { TableRow, TableBody } from '@mui/material';

import { Typography } from 'common/components/Typography';
import { TableHead, TableCell } from 'common/components/Table';

export const COMPONENTS: {
    [key: string]: React.ComponentType<Record<string, unknown>>;
} = {
    Typography,
    TableBody,
    TableRow,
    TableHead,
    TableCell,
};

export type TComponents = keyof typeof COMPONENTS;

export const options = {
    bold: {
        type: 'bold',
    },
    italic: {
        type: 'italic',
    },
    underline: {
        type: 'underline',
    },
    superscript: {
        type: 'superscript',
        clear: 'subscript',
    },
    p: {
        type: 'p',
    },
    h1: {
        type: 'h1',
    },
    h2: {
        type: 'h2',
    },
    h3: {
        type: 'h3',
    },
    h4: {
        type: 'h4',
    },
    li: {
        type: 'li',
    },
    ul: {
        type: 'ul',
    },
    ol: {
        type: 'ol',
    },
    link: {
        type: 'a',
    },
    blockquote: {
        type: 'blockquote',
    },
    table: {
        type: 'table',
    },
    tbody: {
        type: 'tbody',
    },
    tr: {
        type: 'tr',
    },
    th: {
        type: 'th',
    },
    td: {
        type: 'td',
    },
    img: {
        type: 'img',
        rootProps: {
            className: 'slate-img',
        },
    },
    file: {
        type: 'file',
        rootProps: {
            className: 'slate-file',
        },
    },
    media_embed: {
        type: 'media_embed',
        rootProps: {
            className: 'slate-embed',
        },
    },
};
